import { Trash2, RotateCcw } from "lucide-react";

const numCls =
  "w-20 border border-steel-border bg-steel-surface px-2 py-1.5 text-right font-mono text-xs text-steel-text focus:border-steel-accent focus:outline-none";

export const EstimateEditor = ({ lines, setLines, sum, onResetLines }) => {
  const setLine = (key, field, value) =>
    setLines((ls) => ls.map((l) => (l.key === key ? { ...l, [field]: value } : l)));

  const addCustom = () =>
    setLines((ls) => [...ls, { key: `custom:${Date.now()}`, form_id: "", label: "", min: 0, max: 0 }]);

  return (
    <div data-testid="estimate-editor">
      <div className="flex items-center justify-between">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-steel-muted">Estimate line items</p>
        <button
          type="button"
          data-testid="estimate-reset-lines"
          onClick={onResetLines}
          className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-steel-muted transition-colors hover:text-steel-brass"
        >
          <RotateCcw className="h-3 w-3" /> Reset
        </button>
      </div>

      <div className="mt-3 space-y-2">
        {lines.length === 0 && (
          <p className="border border-dashed border-steel-border p-4 text-xs text-steel-muted">
            No lines — select the client&rsquo;s situation, or add a custom line.
          </p>
        )}
        {lines.map((l, i) => (
          <div key={l.key} className="border border-steel-border bg-steel-elevated p-2" data-testid={`estimate-line-${i}`}>
            <div className="flex items-center gap-2">
              <input
                data-testid={`estimate-line-label-${i}`}
                value={l.label}
                onChange={(e) => setLine(l.key, "label", e.target.value)}
                placeholder="Description"
                className="min-w-0 flex-1 border-0 bg-transparent px-1 py-1 text-sm text-steel-text placeholder:text-steel-muted focus:outline-none"
              />
              <button
                type="button"
                data-testid={`estimate-line-remove-${i}`}
                onClick={() => setLines((ls) => ls.filter((x) => x.key !== l.key))}
                aria-label="Remove line"
                className="flex h-7 w-7 shrink-0 items-center justify-center text-steel-muted transition-colors hover:text-red-400"
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
            <div className="mt-1 flex items-center justify-end gap-3">
              <label className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-steel-muted">
                Low $
                <input
                  data-testid={`estimate-line-min-${i}`}
                  type="number"
                  min="0"
                  step="1"
                  value={l.min}
                  onChange={(e) => setLine(l.key, "min", e.target.value)}
                  className={numCls}
                />
              </label>
              <label className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-steel-muted">
                High $
                <input
                  data-testid={`estimate-line-max-${i}`}
                  type="number"
                  min="0"
                  step="1"
                  value={l.max}
                  onChange={(e) => setLine(l.key, "max", e.target.value)}
                  className={numCls}
                />
              </label>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        data-testid="estimate-add-line"
        onClick={addCustom}
        className="mt-3 text-xs font-medium text-steel-muted underline-offset-4 transition-colors hover:text-steel-brass hover:underline"
      >
        + Add a custom line
      </button>

      <div className="mt-5 border-t border-steel-border pt-4">
        <div className="flex items-baseline justify-between">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-steel-muted">Client sees</span>
          <span className="neon-text font-display text-2xl font-medium text-steel-brass" data-testid="nc-estimate">
            ${sum.min.toLocaleString()} – ${sum.max.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EstimateEditor;
